import { DateTime } from 'luxon';

export class TimeZoneChangeEditor {
  id: number;
  secondsOffsetFromUtc: number;
  dateTime: DateTime;
  dateToShow: string;
  deleted: boolean;
  dailyLogRecordId: number;
  timeOfChange: DateTime;
  timeOfChangeToShow: string;
  previousSecondsOffsetFromUtc: number;
  dailyLogDateUtc?: DateTime; // needed only when saving the timezone change to check on leg load complete status using the daily log date
}

export class TimeZoneFilters {
  dateTime?: DateTime;
  /* used in getting the correct timezone for the date. Basically a date entered by the user will be ambiguous, a date form the api will
     not be ambiguous */
  dateAmbiguous?: boolean;
  removeFilterDateOffset?: boolean;
  secondsOffsetFromUtc?: number;
  dailyLogRecordId?: number;
  ignoreId?: number;
}

export class TimeZoneSelectOptions {
  options = {
    title: 'Select a new Time Zone Offset',
    mode: 'md'
  };
}

export class TimeZoneChangeOption<TValue> {
  id: TValue;
  name: string;
  seconds: number;
}

export class DateLostInTimeResult {
  result: boolean;
  timeZone: TimeZoneChangeEditor;
}

export class MultipleTimeZoneResult {
  result: boolean;
  timeZone: TimeZoneChangeEditor;
  possibleOffsets: number[];
  selectedOffsetMinutes?: number;
}



// WEBPACK FOOTER //
// ./src/models/time-zones/time-zone.models.ts